export default {
  loading: false,
  activeStep: 0,
  installationId: null,
  appConfigV2: {
  },
  credentials: {
    sysnode: {
      lp_api_key: '',
    },
    ftp: {
      host: '',
      username: '',
      password: '',
    },
  },
  appDetails: {
    app: {},
    installation: {},
  },
  warehouseList: [],
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/store/states.js